export const initTextWithMedia = () => {
	const components = document.querySelectorAll( 'section.text-with-media' );

	if ( !components.length )
	{
		return;
	}

	const handleComponentResize = ( component ) => {
		if ( window.innerWidth >= 768 && component.offsetHeight > 620 )
		{
			component.classList.add( 'large-text' );
		}
		else
		{
			component.classList.remove( 'large-text' );
		}
	};

	Array.from( components ).forEach( ( it ) => {
		handleComponentResize( it );

		window.addEventListener( 'resize', () => {
			handleComponentResize( it );
		} );
	} );
};
